import { createGlobalStyle } from 'styled-components';
import { colors } from '@10d/tend-ui-tokens/samolet';

export const GlobalStyle = createGlobalStyle`
  .ant-dropdown-menu {
    box-shadow:
    0 8px 22px -6px #18274b0a,
    0px 14px 64px -4px #18274b0a;

    padding: 0;
    border-radius: 8px;
    background-color: ${colors.gray0};
    overflow: hidden;

    .ant-dropdown-menu-item,
    .ant-dropdown-menu-submenu-title {
      display: flex;
      align-items: center;
      min-height: 30px;
      padding-top: 10px;
      padding-bottom: 10px;
      color: ${colors.gray900};

      &:hover {
        background-color: #F7F9FE;
      }
    }

    & &-item-disabled,
    & &-item-disabled:hover {
      color: ${colors.gray400};
      background: ${colors.gray0};
    }
  }
`;
